import { Link, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { useAuthContext } from "../hooks/useAuthContext";

const MeaLink = ({ to, children, permission, isRipple = false, noNavigation = false, ...props }) => {
  const navigate = useNavigate();
  const { hasPermission } = useAuthContext();
  const didHasPermission = hasPermission(permission);

  if (permission !== undefined && !didHasPermission) {
    return children
  }
  return (
    <>
      {((noNavigation === true) && (<span>{children}</span>)) || (
        (isRipple === true) && (
          <Button text className="no-underline text-color hover:bg-gray-200 w-full pt-1 pb-1 " onClick={() => {
            navigate(to);
          }} {...props} label={children}>

          </Button>
        ) || (
          <Link to={to} className="no-underline text-color hover:underline flex align-items-center flex-wrap" {...props}>
            {children}
          </Link>
        )
      )}
    </>
  );
};

export default MeaLink;
